import { ExampleCard } from "../_00Global/ExampleCard";
import { ExampleCardLGBT } from "../_00Global/ExampleCardLGBT";

export const _04BBody = (): JSX.Element => {
  return (
    <div className="flex flex-col items-center justify-center relative">
      <div className="w-full max-w-[1100px] px-4">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-y-10 gap-x-10 lg:gap-[70px_100px] py-[30px] justify-items-center mx-auto max-w-[750px] lg:max-w-none">
          <ExampleCard
            blueCircle="/img/bluecircle.svg"
            photoReplaceFrom="/img/photoreplacefromfill-1.png"
            text="Beau &amp; Andrew"
            text1="Spring Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/beau_&_andrew.mp4?t=2025-01-25T04%3A36%3A54.548Z"
          />
          <ExampleCard
            blueCircle="/img/bluecircle.svg"
            photoReplaceFrom="/img/photoreplacefromfill-2.png"
            text="Amy &amp; Jack"
            text1="Spring Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/amy_&_jack.mp4?t=2025-01-25T04%3A37%3A28.822Z"
          />
          <ExampleCard
            blueCircle="/img/bluecircle.svg"
            photoReplaceFrom="/img/photoreplacefromfill-3.png"
            text="Ashley &amp; Jade"
            text1="Summer Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/ashley_&_jade.mp4?t=2025-01-25T04%3A39%3A11.854Z"
          />
          <ExampleCardLGBT
            LGBTCircle="/img/lgbtcircle.svg"
            ellipse="/img/ellipse-1-1.png"
            text="Laura &amp; Sarah"
            text1="Summer Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/laura_&_sarah.mp4?t=2025-01-25T04%3A39%3A47.660Z"
          />
          <ExampleCard
            blueCircle="/img/bluecircle.svg"
            photoReplaceFrom="/img/photoreplacefromfill-4.png"
            text="Ciara &amp; Jamie"
            text1="Autumn Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/ciara_&_jamie.mp4?t=2025-01-25T04%3A40%3A12.037Z"
          />
          <ExampleCard
            blueCircle="/img/bluecircle.svg"
            photoReplaceFrom="/img/photoreplacefromfill-5.png"
            text="Georgia &amp; Simon"
            text1="Winter Wedding"
            videoUrl="https://pcdodwcjlmnmpabyinsh.supabase.co/storage/v1/object/public/Website%20Videos/georgia_&_simon.mp4?t=2025-01-25T04%3A40%3A39.491Z"
          />
        </div>
      </div>
    </div>
  );
}; 